module.exports = __webpack_public_path__ + "assets/img/D2b.a8bdcd78.jpg";